/**
 * Variant systemName → base game type. A variant reuses the base game's admin editor,
 * profile page, settings defaults and editor routes — add it here ONCE instead of wiring it
 * into ProfileDetailPage / V5GameProfilesPage / the router separately.
 *
 * The variant's menu name + version badge live in the backend GAME_CATALOG; this map is only
 * about which admin UI renders it.
 */
export const GAME_TYPE_ALIASES: Record<string, string> = {
  // React generation of the loot box — same admin editor as lootBoxV2.
  lootBoxV2React: 'lootBoxV2',
  // Streak Claimer V3 with its progress mode fixed (see LOCKED_PROGRESS_MODE).
  streakClaimerV3Streak: 'streakClaimerV3',
  actionClaimerV3: 'streakClaimerV3',
};

/** Resolve a systemName to its base game type (identity when it is not a variant). */
export const resolveBaseGame = (systemName?: string | null): string =>
  (systemName && GAME_TYPE_ALIASES[systemName]) || systemName || '';
